<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M20 7.4v11q0 .6-.5 1.1t-1.1.5H5.6q-.6 0-1.1-.5T4 18.4V5.6q0-.6.5-1.1T5.6 4h11zm-1 .4L16.1 5H5.6q-.3 0-.4.2l-.2.4v12.8q0 .3.2.4l.4.2h12.8q.3 0 .4-.2l.2-.4zm-7 8.7q.8 0 1.4-.5.6-.7.6-1.5t-.6-1.4a2 2 0 0 0-1.4-.6 2 2 0 0 0-1.4.6 2 2 0 0 0-.6 1.4q0 .8.6 1.5.6.5 1.4.5M6.8 9.8h7.4v-3H6.8z"
      />
    </svg>
  </span>
</template>
